import { render, staticRenderFns } from "./ReturnOrderList.vue?vue&type=template&id=f65e1d1a&scoped=true"
import script from "./ReturnOrderList.vue?vue&type=script&lang=js"
export * from "./ReturnOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65e1d1a",
  null
  
)

export default component.exports